<app-accordion title="Global Insights" i18n-title [maxWidth]="maxWidth">
    <p class="text">
        The future of aesthetics is here. Get a unique view of what tomorrow holds for aesthetics to enable evolution for the future.
    </p>
    <div>
        <app-btn [href]="trendsUrl" [style]="buttonStyles.secondary" [icon]="iconTypes.arrowRight" i18n>Read More</app-btn>
    </div>
</app-accordion>